module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "tochla"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/05_ack"
    }
  }, [_vm._v("Editor’s Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tochla"
  }, [_c('a', {
    attrs: {
      "href": "#/06_con"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tochlb"
  }, [_c('a', {
    attrs: {
      "href": "#/08_intro"
    }
  }, [_vm._v("Introduction: Edgy Ethnography in a Little Big Place")]), _vm._v(" \\ Fran Markowitz")]), _vm._v(" "), _c('p', {
    staticClass: "tochp"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/09_pt01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I. Confrontations and Conversions")])])]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/10_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("    How Christian Pilgrims Made Me Israeli")]), _vm._v(" \\ Jackie Feldman")]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("    Mission Not Accomplished: Negotiating Power Relations and Vulnerability among Messianic Jews in Israel")]), _vm._v(" \\ Tamir Erez")]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("    Doing Dimona: An Americanist Anthropologist in an Africanized Israel")]), _vm._v(" \\ John L. Jackson Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "tochp"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/13_pt02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II. State Categories and Global Flows")])])]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("    Seeking Truth in Hip-Hop Music and Hip-Hop Ethnography")]), _vm._v(" \\ Uri Dorchin")]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("    The State of the Jewish Family: Eldercare as a Practice of Corporeal Symbiosis by Filipina Migrant Workers")]), _vm._v(" \\ Keren Mazuz")]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("    Diasporas Collide: Competing Holocausts, Imposed Whiteness, and the Seemingly Jewish Non-Jew Researcher in Israel")]), _vm._v(" \\ Gabriella Djerrahian")]), _vm._v(" "), _c('p', {
    staticClass: "tochp"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/17_pt03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III. Fieldwork to the Point of Worry")])])]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("    Traveling between Reluctant Neighbors: Researching with Jews and Bedouin Arabs in the Northern Negev")]), _vm._v(" \\ Emily McKee")]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/19_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("    On the Matter of Return to Israel/Palestine: Autoethnographic Reflections")]), _vm._v(" \\ Jasmin Habib")]), _vm._v(" "), _c('p', {
    staticClass: "tochl"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v("    Some Kind of Masochist? Fieldwork in Unsettling Territory")]), _vm._v(" \\ Joyce Dalsheim")]), _vm._v(" "), _c('p', {
    staticClass: "tochll"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/21_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v("    The Impurities of Experience: Researching Prostitution in Israel")]), _vm._v(" \\ Hilla Nehushtan")]), _vm._v(" "), _c('p', {
    staticClass: "tochll"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v("    Falling in Love with a Criminal? On Immersion and Self-Restraint")]), _vm._v(" \\ Virginia R. Dominguez")]), _vm._v(" "), _c('p', {
    staticClass: "tochlb"
  }, [_c('span', {
    attrs: {
      "href": "#/23_ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e4ad02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_toc.vue
// module id = 69
// module chunks = 0